import React, {  useEffect, useState} from 'react';
import { useWindowSize } from '../cvp-webgames-core/hooks/useWindowSize';
import { constants } from '../misc/constants';
import GamePage from './Game';
import MainMenuPage from './MainMenu';
export enum Windows {
	Nothing,
	MainMenu,
	Level1,
	Level2,
	Level3,
	Level4,
	Level5
}
const MainPage = () => {
	const [windowToUse, setWindowToUse] = useState(Windows.MainMenu);
	var isInitializing: boolean = false;

	const windowSize: any = useWindowSize();

	const scale = Math.min(windowSize.width / 1920, windowSize.height / 1080);

	useEffect(() => {
		if(!isInitializing) {
			var url = new URL(window.location.href);
			var search_params = url.searchParams;
			var w: any = search_params.get('w');
			if(w && parseInt(w) !== Windows.Nothing) {
				setWindowToUse(parseInt(w));
			} else {
				setWindowToUse(Windows.MainMenu);
			}
			setTimeout(() => {
				(window as any)['uiContainerChanged']();
			}, 0);
			isInitializing = true;
		}
	})

	const updateWindow = (windowToUse: Windows): void => {
		//setWindow(window);
		var url = new URL(window.location.href);
		var search_params = url.searchParams;
		
		search_params.set('w', windowToUse.toString());

		url.search = search_params.toString();

		window.location.href = url.toString();
	}
	
	return (
		<div style={{
			position: "fixed",
			width: "1920px",
			height: "1080px",
			transform: `scale(${scale}) translate(-50%, -50%)`,
			transformOrigin: "0px 0px",
			top: "50%",
			left: "50%",
		}}>
			{windowToUse === Windows.MainMenu ? <MainMenuPage updateWindow={updateWindow}></MainMenuPage> : (null)}
			{windowToUse === Windows.Level1 ? <GamePage updateWindow={updateWindow} scenarioId={constants.scenarios.scenario1.id}></GamePage>: (null)}
			{windowToUse === Windows.Level2 ? <GamePage updateWindow={updateWindow} scenarioId={constants.scenarios.scenario2.id}></GamePage>: (null)}
			{windowToUse === Windows.Level3 ? <GamePage updateWindow={updateWindow} scenarioId={constants.scenarios.scenario3.id}></GamePage>: (null)}
			{windowToUse === Windows.Level4 ? <GamePage updateWindow={updateWindow} scenarioId={constants.scenarios.scenario4.id}></GamePage>: (null)}
			{windowToUse === Windows.Level5 ? <GamePage updateWindow={updateWindow} scenarioId={constants.scenarios.scenario5.id}></GamePage>: (null)}
		</div>
	);
};

export default MainPage;
